import CPDRegistrations from '@/features/membership/admin/routes/CPDRegistrations'
import { isAdminUser } from '@/lib/role-guards'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/admin/cpd-registrations')(
  {
    beforeLoad: ({ context }) => {
      if (context.auth.isLoading) {
        return
      }
      if (!isAdminUser(context.auth.user)) {
        throw redirect({ to: '/dashboard' })
      }
    },
    component: CPDRegistrations,
  },
)
